<template>
	<li v-if="publication === 'removed'" class="c-mini-cards__item property">
		<a class="c-mini-card" v-bind:href="'/go/' + reference">
			<div class="c-mini-card__thumb">
				<span class="sash sash--overlay removed">{{$t("banners.removed")}}</span>
				<button v-if="isfav" v-on:click.prevent="favRemove" class="c-save-btn is-saved">
					<icon name="heart" />
					<span class="c-save-btn__value">{{$t("favourites.button.remove")}}</span>
				</button>
				<img 
					:sizes="imageSizes"
					:src="placeholderSrc"
					:srcset="placeholderSrcSet"
					>
			</div>
			<div class="c-mini-card__body">
				<div class="c-mini-card__meta">
					<span class="c-mini-card__location">{{ reference }}</span>
				</div>
				<p class="c-mini-card__title">{{$t("property.removed_explaination")}}</p>
				<span class="sash removed">{{$t("banners.removed")}}</span>
			</div>
		</a>
	</li>
	<li v-else class="c-mini-cards__item property">
		<a class="c-mini-card" v-bind:href="'/go/' + reference">
			<div class="c-mini-card__thumb">
				<span v-if="banner !== ''" :class="'sash sash--overlay ' + banner">{{$t("banners."+banner)}}</span>
				<button 
					v-if="isfav"
					v-on:click.prevent="favRemove"
					class="c-save-btn is-saved"
					>
					<icon name="heart" />
					<span class="c-save-btn__value">{{$t("favourites.button.remove")}}</span>
				</button>
				<button
					v-if="!isfav"
					v-on:click.prevent="favAdd"
					class="c-save-btn"
					>
					<icon name="heart" />
					<span class="c-save-btn__value">{{$t("favourites.button.add")}}</span>
				</button>
				<img 
					:sizes="imageSizes"
					:src="imageSrc"
					:alt="title" 
					:srcset="imageSrcSet"
					>
				<div class="c-overlay">	
					<span class="c-mini-card__price" v-if="showprice == 1">
						<span v-if="classid == 'development'">{{$t("property.pricing.from")}}</span>
						{{formatted_price}}
					</span>
					<span class="c-mini-card__price" v-else>
						{{$t("property.pricing.por")}}
					</span>
				</div>
			</div>
			<div class="c-mini-card__body">
				<div class="c-mini-card__meta">
					<span class="c-mini-card__location">{{ reference }} {{type_title}}</span>
					<span class="c-mini-card__price" v-if="showprice == 1">
						<span v-if="classid == 'development'">{{$t("property.pricing.from")}}</span>
						{{formatted_price}}
					</span>
					<span class="c-mini-card__price" v-else>
						{{$t("property.pricing.por")}}
					</span>
				</div>
				<p class="c-mini-card__title">{{title}}</p>
				<span v-if="banner !== ''" :class="'sash ' + banner">{{$t("banners."+banner)}}</span>
			</div>
		</a>
	</li>
</template>

<script>
	import Icon from './icon.vue';
	export default {
		name: 'property',
		components: {Icon},
		props: ['reference','title','price','type_title','image','showprice','classid','isfav','publication','banner'],
		data () {return {
			imageSizes:'(min-width:34em) 200px, calc(100vw - 3rem)',
			placeHolderImage: {path: 'placeholder', id: 'no-images'},
			sourceset: [
				{format:'4x3_320w', size:'320w'},
				{format:'4x3_420w', size:'420w'},
				{format:'4x3_560w', size:'560w'}
			]
		}},
		computed: {
			imageSrc: function(){
				// Return the first sourceset option
				return this.gen_imageSrc(this.image.path, this.sourceset[0].format, this.image.id);
			},
			placeholderSrc: function(){
				// Return the first sourceset option
				return this.gen_imageSrc(this.placeHolderImage.path, this.sourceset[0].format, this.placeHolderImage.id);
			},
			imageSrcSet: function(){
				return this.gen_sourceSet(this.image);
			},
			placeholderSrcSet: function(){
				return this.gen_sourceSet(this.placeHolderImage);
			},
			formatted_price: function(){
				if(!this.showprice){
					return '';
				}
				// Create a price string
				var suffix = "";
				switch(this.classid){
					case 'res_short':{
						suffix = '/wk';
						break;
					}
					case 'res_rent':{
						suffix = '/mth';
						break;
					}
				}

				return '€' + (this.price/1).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + suffix;
			}
		},
		methods: {
			favRemove: function(){
				// Call the remove event on the parent Vue component
				this.$emit('favRemove', this.reference);
			},
			favAdd: function(){
				// Call the remove event on the parent Vue component
				this.$emit('favAdd', this.reference);
			},
			gen_imageSrc: function(path, setname, id){
				return 'https://images.lucasfox.com/' + path + '/' + setname + '/' + id + '.jpg';
			},
			gen_sourceSet: function(img){
				var rtn = [];
				this.sourceset.forEach(function(set){
					rtn.push(this.gen_imageSrc(img.path, set.format, img.id) + ' ' + set.size);
				},this);
				return rtn.join(', ');
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/property.vue